<div class="wrapper">
  <div class="iw-signin-dialog">
    <div class="header iw-bold-18">
      <iw-logo />
    </div>

    <form class="body" [formGroup]="form" (ngSubmit)="verify()">
      <div class="content">
        <div class="text">
          <p
            class="title d-flex flex-col align-center text-center"
            translate="signin.tfaEnable.header"
          ></p>
          <p
            class="message text-center"
            translate="signin.tfaEnable.message"
          ></p>
        </div>

        @if (manualSetupUri) {
          <div class="qrcode-box d-flex gap-3">
            <div class="qrcode-desktop">
              <ng-container *ngTemplateOutlet="qrCodeTemplate"></ng-container>
            </div>

            <div class="instructions d-flex flex-col align-start gap-3">
              <div class="step">
                <span class="step-circle">1</span>
                <p class="message">
                  {{ "signin.tfaEnable.instruction11" | translate }}

                  <a
                    target="_blank"
                    fuButton
                    uiType="quinary"
                    href="https://authy.com"
                  >
                    Authy </a
                  >,

                  <a
                    target="_blank"
                    fuButton
                    uiType="quinary"
                    [href]="
                      isIOS
                        ? 'https://apps.apple.com/ru/app/google-authenticator/id388497605'
                        : 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2'
                    "
                  >
                    Google Authenticator
                  </a>

                  {{ "signin.tfaEnable.instruction12" | translate }}
                </p>
              </div>

              <div class="step">
                <span class="step-circle">2</span>
                <div class="messages">
                  <p
                    class="message"
                    translate="signin.tfaEnable.instruction2"
                  ></p>
                  <div class="qrcode-mobile">
                    <ng-container
                      *ngTemplateOutlet="qrCodeTemplate"
                    ></ng-container>
                  </div>
                </div>
              </div>

              <div class="step">
                <span class="step-circle">3</span>
                <div>
                  <p
                    class="message"
                    translate="signin.tfaEnable.control.code"
                  ></p>
                  <fu-simple-input
                    [useOutlineLabel]="false"
                    class="fu-form-container"
                    formControlName="code"
                    [placeholder]="
                      'signin.tfa.form.placeholder.code' | translate
                    "
                    [errorDictionary]="errorDictionary"
                  />
                </div>
              </div>
            </div>
          </div>
        }

        <div class="actions">
          <button
            type="submit"
            fuButton
            size="l"
            uiType="primary"
            translate="signin.tfaEnable.btn.verify"
            [disabled]="!form.valid || isLoading"
          ></button>
        </div>
      </div>
    </form>
  </div>
</div>
<ng-template #qrCodeTemplate>
  <div class="qrcode-wrapper">
    <a [href]="manualSetupUri">
      <qrcode
        [qrdata]="manualSetupUri"
        [width]="172"
        [errorCorrectionLevel]="'M'"
      />
    </a>
  </div>
</ng-template>
